var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q5qsm3x85a",
    d: "M16.667 11.458c1.729 0 3.114-1.396 3.114-3.125s-1.385-3.125-3.114-3.125c-1.73 0-3.125 1.396-3.125 3.125 0 1.73 1.396 3.125 3.125 3.125zm-8.334 0c1.73 0 3.115-1.396 3.115-3.125s-1.386-3.125-3.115-3.125c-1.729 0-3.125 1.396-3.125 3.125 0 1.73 1.396 3.125 3.125 3.125zm0 2.084c-2.427 0-7.291 1.218-7.291 3.646v2.604h14.583v-2.605c0-2.427-4.865-3.645-7.292-3.645zm8.334 0c-.302 0-.646.02-1.01.052 1.208.875 2.051 2.052 2.051 3.594v2.604h6.25v-2.605c0-2.427-4.864-3.645-7.291-3.645z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -25) translate(79 25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hsn6qp9a3b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q5qsm3x85a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#hsn6qp9a3b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H52.083V52.083H0z",
    transform: "translate(-13.542 -13.542)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPeople);
export default __webpack_public_path__ + "static/media/ic-people.ea9631b6dec8a7b97271ab7f72a99994.svg";
export { ForwardRef as ReactComponent };